import { filterMenu } from '@/constants/menu.constant';
import { PERMISSION } from '@/constants/permission.constant';
import store from '@/store';
import { addressYescar } from './address-yescar.route';
import { position } from './position.route';
import { termCondition } from './term-condition';

const findAllPermission = store.getters['userPermission/getPermissions'];

const isRedirectRoute = (findAllPermission?.data || []).map((permission) => permission.action)?.flat();

const isRedirect = filterMenu(isRedirectRoute);
const [, , , , configurations] = isRedirect || {};
const { children } = configurations || {};
const [firstChild] = children || [];

export const configurationsRoute = [
  {
    path: '/configurations',
    name: 'configurations',
    meta: { requiresAuth: true, permissions: [PERMISSION.DEFAULT] },
    component: () => import('@/views/configurations/Index.vue'),

    children: [
      {
        path: '/configurations/positions',
        name: 'positions',
        component: () => import('@/views/configurations/positions/List.vue'),
        meta: { requiresAuth: true, permissions: [PERMISSION.POSITION_READ] },
      },

      {
        path: '/configurations/term-condition',
        name: '/term-condition',
        component: () => import('@/views/configurations/term-condition/TermConditionList.vue'),
        meta: {
          requiresAuth: true,
          permissions: [PERMISSION.TERM_CONDITIONS_READ],
        },
        props: { defaultProp: 'defaultValue' }, // Pass default props here
      },
    ],
  },
  ...position,
  ...termCondition,
  ...addressYescar,
];
